export const cardPadding = 20
export const titleMarginBottom = 30
